import styled from 'styled-components';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { ButtonGroup, TextField, FormControl, Paper, Button, CircularProgress, Modal, Card } from '@material-ui/core';

export const Container = styled.div`
  padding: 50px 5%;
`;

export const PaperForm = styled(Paper)`
  padding: 2%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

export const Form = styled(FormControl)`
  && {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width:100%;
    justify-content: center;
    align-items: flex-end;
  }
`

export const InputContainer = styled.div`
  margin: 5px 20px;
  color: var(--primary);
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 2;

  
  @media(min-width: 0px) {
		margin: 10px 0;
		width : 100%;
	}

	@media(min-width: 600px) {
		margin: 10px 5px;
    width : 45%;
    max-width: 100%;
	}

	@media(min-width: 960px) {
		margin: 10px 10px;
		width : 45%;
    max-width: 100%;
	}

	@media(min-width: 1280px) {
		margin: 10px 10px;
		width: 45%;
    max-width: 100%;
	}

  & {
    width : ${props => props.size};
    max-width: ${props => props.size};
  }

`

export const InputText = styled(TextField)`
  width: 100%;
  color: var(--primary);

  .MuiInput-underline:after {
    border-bottom: solid 2px var(--primary);
  }
`

export const DatePicker = styled(KeyboardDatePicker)`
  .MuiInput-underline:after {
    border-bottom: solid 2px var(--primary);
  }
`

export const ButtonGrouped = styled(ButtonGroup)`
  margin-top: 10px;
`

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
`

export const ButtonColor = styled(Button)`
  && {
    background-color: ${props => props.bgColor ? props.bgColor : 'var(--primary)'} ;
    color: ${props => props.txtColor ? props.txtColor : 'var(--white)'};
    margin-left: 15px;
    margin-top: 10px;

    :hover {
      background-color: ${props => props.bgColor ? props.bgColor : 'var(--primary)'} ;
      color: ${props => props.txtColor ? props.txtColor : 'var(--white)'};
      box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
    }
  }
`

export const ContainerLoading = styled.div`
  position: relative;
`

export const ButtonLoading = styled(CircularProgress)`
 && {
  color: var(--primary);
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -6px;
  margin-left: -12px;
 }
`


export const ModalHelp = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;

  & :focus {
    outline: none;
  }
`

export const CardHelp = styled(Card)`
  width: 90%;
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 5px 10px 10px;
`

export const CardBody = styled.div`
  display: flex;
`

export const CardItem = styled.div`
  width: 50%;
  padding: 10px 20px;

  @media(max-width: 960px) {
		width: 100%;
	}
`